import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';

interface ChatInputPopupProps {
    messageText: string;
    setMessageText: (text: string) => void;
    sendValidationError?: string | null;
    handleSend: () => void;
}

export const ChatInputPopup: React.FC<ChatInputPopupProps> = ({
    messageText,
    setMessageText,
    sendValidationError,
    handleSend,
}) => (
    <div className="border-t border-subtle bg-card p-2.5">
        <div className="flex items-center gap-2">
            <input
                type="text"
                id="chat-popup-message-input"
                name="chat-popup-message-input"
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSend();
                    }
                }}
                placeholder="Digite sua mensagem..."
                aria-label="Digite sua mensagem"
                autoComplete="off"
                aria-invalid={!!sendValidationError}
                aria-describedby={sendValidationError ? 'chat-popup-send-error' : undefined}
                className={`flex-1 px-3 py-1.5 text-[16px] md:text-[length:var(--text-base)] border bg-card text-default rounded-lg focus:outline-none placeholder-muted transition-colors ${
                    sendValidationError
                        ? 'border-destructive focus:border-destructive'
                        : 'border-border focus:border-primary'
                }`}
            />
            {messageText.trim() && (
                <button
                    onClick={handleSend}
                    className="w-7 h-7 bg-primary text-white rounded-full hover:bg-primary-dark transition-colors flex items-center justify-center flex-shrink-0"
                    aria-label="Enviar"
                >
                    <AppIcon name="send" className="w-3 h-3" />
                </button>
            )}
        </div>
        {sendValidationError && (
            <p id="chat-popup-send-error" className="mt-1.5 text-xs text-destructive" role="alert">
                {sendValidationError}
            </p>
        )}
    </div>
);
